  <template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <v-btn @click="updateProfile()" v-if="selectedItems.length > 0">
        Add selected items</v-btn
      >
      <v-autocomplete
        v-model="selectedItems"
        :items="filteredItems"
        v-if="show"
        attach
        chips
        item-text="item_name"
        item-value="item_id"
        label="type something"
        search-input="filter"
        flat
        multiple
        @update:search-input="searchItems"
      ></v-autocomplete>
      <div v-if="items && !loading">
        <v-chip :key="index" v-for="(item, index) in items"
          >{{ item.item_name }}
          <v-icon @click="removeItem(item)">mdi-close</v-icon>
        </v-chip>
      </div>
      <v-skeleton-loader type="card" v-if="loading"></v-skeleton-loader>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="show = !show">Add more items</v-btn>
    </v-card-actions>
  </v-card>
</template>

  <script>
import { mapState } from "vuex";

export default {
  props: ["title", "list"],
  data() {
    return {
      filter: null,
      selectedItems: [],
      show: false,
      loading: false,
    };
  },
  computed: mapState({
    ownProfile: (state) => state.profiles.ownProfile,
    items(state) {
      return state.profiles.ownProfile[this.list];
    },
    filteredItems(state) {
      if (this.filter) {
        let filtered_items = state.items.miscellaneous.filter((e) =>
          e.item_name.toLowerCase().includes(this.filter.trim().toLowerCase())
        );
        return filtered_items;
      }
      return state.items.miscellaneous;
    },
  }),
  methods: {
    searchItems(e) {
      let tempFilter = e;
      let exclude = this.items.map((e) => e.item_id).join(",");
      if (exclude) {
        tempFilter = tempFilter + "&exclude=" + exclude;
      }
      let payload={
        'tempFilter': tempFilter,
        'profileId': this.ownProfile.id,
        'list': this.list,
      }

      this.$store.dispatch("getSearchMiscellaneousProfile", payload);
    },
    removeItem(item) {
      this.loading = true;
      // Remove the item from the list and update the profile.
      this.ownProfile[this.list] = this.ownProfile[this.list].filter(
        (e) => e.item_id != item.item_id
      );

      let payload = this.profileUpdateFieldsFormat(this.ownProfile);
      this.$store
        .dispatch("updateProfile", payload)
        .then(() => (this.loading = false));
    },
    updateProfile() {
      this.loading = true;
      let payload = this.ownProfile;
      payload = this.profileUpdateFieldsFormat(payload);
      payload[this.list].push(...this.selectedItems);

      this.$store
        .dispatch("updateProfile", payload)
        .then(() => (this.loading = false));
      this.selectedItems = [];
    },
    profileUpdateFieldsFormat(payload) {
      payload["owned"] = this.ownProfile["owned"].map((e) => e.item_id);
      payload["preferred"] = this.ownProfile["preferred"].map((e) => e.item_id);
      payload["owned_games"] = this.ownProfile["owned_games"].map(
        (e) => e.item_id
      );
      payload["preferred_games"] = this.ownProfile["preferred_games"].map(
        (e) => e.item_id
      );
      payload["accepted_documents"] = this.ownProfile["accepted_documents"].map(
        (e) => e.id
      );
      return payload;
    },
  },
};
</script>


  <style scoped lang="scss">
.badge {
  color: red;
}
.modal-list-container {
  padding: 24px;
  width: 100%;
  overflow: scroll;
  .list-group-item {
    max-width: 100px;
  }
  input {
    width: 100%;
    border-bottom: 1px solid #34395e;
    border-left: 1px solid #34395e;
    border-radius: 0 24px 0 24px;
    &:focus {
      background: rgba(52, 57, 94, 0.1);
    }
    outline: none;
    padding: 8px 12px;
    margin-bottom: 12px;
  }

  min-height: 150px;
  .list-container {
    max-height: 300px;
    overflow: auto;
  }

  .item {
    text-align: center;
    padding: 8px 12px;
    margin: 8px;
    border-radius: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      display: block;
      i {
        color: #9ca7f4;
      }
    }
  }
}
</style>
